(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-recharge-benefits"] && !Shopify.designMode) return;
  try {
    
  
  function rechargeBenefits(){
    $('.onetime-radio').append("<div id='oneTimeVisible' class='benefits-visible'></div>");
    $('.subscription-radio').append("<div id='subVisible' class='benefits-visible'></div>");
    var oneTimeHidden = document.getElementById('oneTimeBenefits');
    var oneTimeVisible = document.getElementById('oneTimeVisible');
    oneTimeVisible.innerHTML = oneTimeHidden.innerHTML;
    var subHidden = document.getElementById('subBenefits');
    var subVisible = document.getElementById('subVisible');
    subVisible.innerHTML = subHidden.innerHTML;
  }
  window.onload = rechargeBenefits;
  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-custom"] && !Shopify.designMode) return;
  try {
    
  var cartNotification = document.getElementById('cart-notification');
  var notificationClose = document.getElementById('notification-close');
  var buyButton = document.getElementsByClassName('product-form__submit');
  buyButton[0].onclick = function() {
    cartNotification.classList.add('animate', 'active');
  }
  notificationClose.onclick = function() {
    cartNotification.classList.remove('active');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (window.innerWidth < 500) {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
  }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (window.innerWidth < 500) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (window.innerWidth < 500) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-custom-new"] && !Shopify.designMode) return;
  try {
    
  var swiperHero = new Swiper('.swiper.is-hero-swiper', {
  	slidesPerView: 1,
    speed: 1,
    loop: 'true',
    effect: "fade",
    fadeEffect: {
      crossFade: 'true'
    },
    autoplay: {
       delay: 1500
     }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-custom"] && !Shopify.designMode) return;
  try {
    
  var swiperHero = new Swiper('.swiper.is-hero-swiper', {
  	slidesPerView: 1,
    speed: 1,
    loop: 'true',
    effect: "fade",
    fadeEffect: {
      crossFade: 'true'
    },
    autoplay: {
       delay: 1500
     }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-benefits-custom"] && !Shopify.designMode) return;
  try {
    
   var swiperBenefits = new Swiper('.swiper.is-benefits', {
  	slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  var cards = document.querySelectorAll('.benefits-card');
  [...cards].forEach((card)=>{
    card.addEventListener( 'click', function() {
      card.classList.toggle('is-flipped');
    });
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-faqs-custom"] && !Shopify.designMode) return;
  try {
    
  var acc = document.getElementsByClassName("accordion-title");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      /* Toggle between adding and removing the "active" class,
      to highlight the button that controls the panel */
      this.classList.toggle("active");
      /* Toggle between hiding and showing the active panel */
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-custom"] && !Shopify.designMode) return;
  try {
    
   var swiperFeatured = new Swiper('.swiper.is-featured-collection', {
  	slidesPerView: 1,
    spaceBetween: 15,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 5,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
   var swiperHow = new Swiper('.swiper.is-how-it-works', {
  	slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: 'true',
    },
    breakpoints: {
      768: {
      },
      992: {
        slidesPerView: 3,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-swiper"] && !Shopify.designMode) return;
  try {
    
  var swiperTestimonials = new Swiper(".swiper.is-testimonials", {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        769: {
          slidesPerView: 2,
        },
        991: {
          slidesPerView: 3,
        }
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-custom"] && !Shopify.designMode) return;
  try {
    
  var swiperTestimonials = new Swiper('.swiper.is-testimonials', {
  	slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
